export const MODAL_FOOTER_CANCEL_BUTTON_CLASS =
  "px-4 py-2 text-xs font-medium text-gray-500 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap";

export const MODAL_FOOTER_PRIMARY_BUTTON_CLASS =
  "px-4 py-2 text-xs font-medium text-white rounded-lg transition-opacity hover:opacity-90 cursor-pointer whitespace-nowrap";

export const MODAL_FOOTER_PRIMARY_BUTTON_STYLE = { backgroundColor: "#830051" } as const;
